export const state = {
  status: '',
}

export const mutations = {
  SET_STATUS(state, payload) {
    state.status = payload
    localStorage.setItem('stateAddress', payload)
  },
}
